import { isIOSVersionGreaterThan17 } from "../util/deviceType"
import MOLocation from "../util/MOLocation"

export const Views = {
  LOADING: "LOADING",
  HOME: "HOME-PAGE",
  NOT_FOUND: "NOT-FOUND-404-PAGE",
  MEETING_ROOM: "MEETING-ROOM",
  BYE: "BYE-PAGE",
  RECORDING_VIEW: "RECORDING-VIEW",
  PLANS_VIEW: "PLANS-VIEW",
  REGISTER_VIEW: "REGISTER-VIEW",
  LOGIN_VIEW: "LOGIN-VIEW",
  AVATARS_VIEW: "AVATARS-VIEW"
}

export const Routes = {
  HOME: "/",
  SHOWS: "/shows",
  AVATARS: "/avatars",
  PLANS: "/plans",
  REGISTER: "/user-register",
  LOGIN: "/user-login",
  VERIFY: "/user-verify",
  PASSWORD_RESET: "/user-password-reset",
  JOURNEY: "/journey",
  LESSON: "/lesson",
  JOURNEY_SUB: "/journey/:subtopic",
  ACCOUNT: "/account",
  ONBOARDING: "/onboarding"
}

export const SUM_FOOTER_HEIGHT_AND_SMALL_VIDEO = 150
export const FOOTER_HEIGHT = 50
export const RemoteVideoWindowsLimit = {
  FORMODERATORS: 4,
  FORBROADCASTERS: 4
}
export const HIGH_VIDEO_STREAM_TYPE = 0
export const LOW_VIDEO_STREAM_TYPE = 1

export const IS_SHOW_RESOLUTION_BOX =
  MOLocation.getURLParamValue("showResolution") ?? false
export const IS_RECORDING_VIEW =
  MOLocation.getURLParamValue("recordingView") ?? false
export const HIDE_GRID_TITLE =
  MOLocation.getURLParamValue("hideGridTitle") ?? false
export const USE_MOBILE_UI: boolean =
  !!MOLocation.getURLParamValue("useMobileUI")
export const TRULIENCE_TEST_DEPLOY: boolean = !!MOLocation.getURLParamValue(
  "trulienceTestDeploy"
)
export const GRID_PAGE_NAME: string = MOLocation.getURLParamValue(
  "gridPageName"
) as string
export const SHOW_AVATARS_BACK_BUTTON_FOR_MOBILE: boolean =
  !!MOLocation.getURLParamValue("showAvatarsBackButtonForMobile")

// Render stream on canvas if url param is set to true or on ios devices
const renderStreamOnCanvasUrlParam = MOLocation.getURLParamValue(
  "renderStreamOnCanvas"
)
export const RENDER_STREAM_ON_CANVAS =
  // Use the URL parameter value if it exists, or false if it's null or undefined
  (renderStreamOnCanvasUrlParam ?? false) ||
  // Enable rendering on canvas for iOS devices if the URL parameter is not explicitly set to false
  (isIOSVersionGreaterThan17() && renderStreamOnCanvasUrlParam !== false)

export const RECORDING_USER_ID = "101"

let baseUrl = MOLocation.getLocation().origin
let hostname = MOLocation.getLocation().hostname

if (!baseUrl || hostname === "localhost") {
  baseUrl = "https://livesell.co"
}
if (!hostname || hostname === "localhost") {
  hostname = "livesell.co"
}

export const DOMAIN_URL = baseUrl
export const DOMAIN_HOSTNAME = hostname
export const LIVESELL_URL = "https://livesell.co"
export const CURRENT_URL = MOLocation.getLocation().href

export const MILLISECOND = 1000
export const HUNDRED_MILLISECOND = 100

export const RECONNECT_TIMEOUT = 60 // In Second ie 60sec
export const AUTO_DISCONNECT_TIMEOUT_WHEN_MOD_LEAVE = 60 * 60 * 1000 // 60 min
export const AUTO_DISCONNECT_TIMEOUT = 120 * 60 * 1000 // 120 min

export const HIDE_PLAYER_CONTROLLER_TIMEOUT = 4000

// UI
export const HEIGHT_CUSTOM_PLAYER_BAR = 55
export const GAP_BETWEEN_OVERLAY_AND_BOTTOM_EDGE = 16
export const CHAT_INPUT_FIELD_HEIGHT = 52
export const SELECTED_REPLY_MESSAGE_HEIGHT = 60
// Mobile UI
export const HEIGHT_SERVICE_PANEL_MOBILE_BUTTON = 35
export const HEIGHT_SERVICE_PANEL_MOBILE_BOTTOM_TAB = 52

// Tab Index
export const CHAT_DESKTOP_TAB_INDEX = "2"
export const SHOW_DESKTOP_TAB_INDEX = 8

// Z-index
export const MODAL_Z_INDEX = 1000000000
export const VIDEO_OVERLAY_Z_INDEX = 1000000000

export const ASPECT_RATIO_16_9 = 16 / 9

export const IS_ANDROID_NATIVE_APP = !!window.AndroidNativeHandler
